import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getWeeklyRichEditPermissions } from '@op/services';
import { gameInfoType } from '@op/types/common';
import { useEffect, useState, createContext, useMemo } from 'react';

export const WeeklyReportContext = createContext<{
  canEditSummary: boolean;
  canEditConfig: boolean;
}>({
  canEditSummary: false,
  canEditConfig: false,
});

export default function useWeeklyReportPermission({
  gameInfo,
}: {
  gameInfo: gameInfoType;
}) {
  const [canEditSummary, setCanEditSummary] = useState(false);
  const [canEditConfig, setCanEditConfig] = useState(false);

  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
    clear: () => {
      setCanEditSummary(false);
      setCanEditConfig(false);
    },
  });

  function requestPermission() {
    return wrapperCancelRequest(getWeeklyRichEditPermissions, gameInfo)
      .then(data => {
        setCanEditSummary(data?.summary_edit_perm || false);
        setCanEditConfig(data?.config_edit_perm || false);
      })
      .catch(() => {});
  }

  useEffect(() => {
    if (gameInfo.edition_unified_id) {
      requestPermission();
    }
  }, [gameInfo]);

  const contextParams = useMemo(
    () => ({ canEditSummary, canEditConfig, loading }),
    [canEditSummary, canEditConfig, loading],
  );

  return { canEditSummary, canEditConfig, loading, contextParams };
}
